import React, { useEffect, useState } from 'react';
import { BsBarChartFill } from "react-icons/bs";
import { PiScalesFill } from "react-icons/pi";
import ResetMapToOriginalData from '../../../core/resetMapToOriginalData.js';

const ResetLandData = ({
    isComparing,
    handleCompareClick,
    mapRef,
    globalRefs,
    globalState
}) => {

    let originalGeoJSONforComparingRef = globalRefs.originalGeoJSONforComparingRef;
    let isResetLandDataConfirmationModalOpen = globalState.isResetLandDataConfirmationModalOpen;
    let setIsResetLandDataConfirmationModalOpen = globalState.setIsResetLandDataConfirmationModalOpen;

    const ResetMapToOriginalDataClick = () => {
        setIsResetLandDataConfirmationModalOpen(true);
    }

    return (
        <div style={{ position: 'absolute', bottom: '250px', width: '95%' }}>
            {/* <div className="resetLandDataButton" onClick={ResetMapToOriginalDataClick}>
                <div>
                    Reset Land data
                </div>
            </div> */}
        </div>
    );
};

export default ResetLandData;